module.exports = __webpack_public_path__ + "7906550c8dd616598bef5ce17e25dbbe.fbx";